import { ReactNode } from 'react';
import styled from '@emotion/styled';

interface AccordionListProps {
  children: ReactNode;
}

function AccordionList({ children }: AccordionListProps) {
  return <ListContainer>{children}</ListContainer>;
}

const ListContainer = styled('div')`
  display: flex;
  flex-direction: column;
`;

export { AccordionList };
